<template>
  <div class="form-group" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <input ref="element" type="checkbox" v-bind:checked="value ? 'checked' : ''">
  </div>
</template>

<script>
import IconsRender      from '../../templates/widgets/icons-render'
import DictionaryLoader from '@/model/loader/dictionary-loader'

export default {
  name:       'Toggle',
  components: {
    IconsRender
  },
  props:      {
    element: {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },
  data () {
    return {
      value:     0,
      switchery: null,
      render:    true
    }
  },

  mounted () {
    const Switchery = require('switchery')
    const options   = { disabled: false }

    options.disabled = this.element.readonly

    const element  = this.$refs.element
    this.switchery = new Switchery(element, options)
    this.switchery.switcher.addEventListener('click', () => {
      this.value = element.checked ? 1 : 0
      this.$emit('changeValue', { element: this.element, value: this.value })
    })
  },

  methods: {
    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.value = value

      if (!!this.value !== this.switchery.isChecked()) {
        this.switchery.setPosition(true)
      }
    },
    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  },

  setRender (render) {
    this.render = render
  }
}
</script>

<style>
.form-group .switchery {
  display: block;
}
</style>
